<p-table
    #dt
    [value]="data"
    [columns]="cols"
    [rowHover]="true"
    dataKey="id"
    exportFilename="usuarios-{{ clinic.slug }}"
>
    <ng-template pTemplate="caption">
        <div class="flex justify-content-end flex-wrap align-items-center">
      <span class="p-input-icon-left mr-2">
        <i class="pi pi-search"></i>
        <input
            pInputText
            type="text"
            #filter
            (input)="onGlobalFilter(dt, $event)"
            placeholder="Buscar"
            class="w-full"
        />
      </span>
            <p-button icon="pi pi-download" label="Exportar" (onClick)="dt.exportCSV()" />
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th class="hidden" scope="col"></th>
            <th pSortableColumn="name" scope="col">Nombre
                <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="apellidos" scope="col">
                Apellidos
                <p-sortIcon field="apellidos"></p-sortIcon>
            </th>
            <th pSortableColumn="email" scope="col">Email
                <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th scope="col">Teléfono</th>
            <th scope="col">Código postal</th>
            <th scope="col"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr>
            <td class="hidden">{{ data.id }}</td>
            <td>
                {{ data.name ?? '-' }}
            </td>
            <td>
                {{ data.apellidos ?? '-' }}
            </td>
            <td>
                {{ data.email ?? '-' }}
            </td>
            <td>
                {{ data.phoneNumber ?? '-' }}
            </td>
            <td>
                {{ data.zipCode ?? '-' }}
            </td>
            <td class="text-center">
                <div class="flex">
                    <button
                        pButton
                        pRipple
                        icon="pi pi-eye"
                        class="p-button-rounded p-button mr-2"
                        (click)="view(data)"
                    ></button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog
    header="Usuario"
    [modal]="true"
    [(visible)]="viewModal"
    [resizable]="false"
    [maximizable]="true"
    appendTo="body"
    [style]="{ width: '50vw' }"
>
    <ul class="list-none p-0 m-0">
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Nombre y apellidos</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {{ user?.name }} {{ user?.apellidos }}
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Email</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {{ user?.email }}
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Teléfono</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {{ user?.phoneNumber }}
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Código postal</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {{ user?.zipCode }}
            </div>
        </li>
    </ul>
    @if (user?.pets.length > 0) {
        <p-divider />
        <h4 class="text-500 w-6 font-medium text-base ml-2 mt-0 mb-2">Mascotas:</h4>
        <p-table
            [value]="user.pets"
            [scrollable]="true"
            scrollHeight="flex"
            [tableStyle]="{ 'min-width': '50rem' }"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col">Especie</th>
                    <th scope="col">Raza</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Género</th>
                    <th scope="col">Edad</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-pet>
                <tr>
                    <td>{{ pet.especie }}</td>
                    <td>{{ pet.raza }}</td>
                    <td>{{ pet.name }}</td>
                    <td>{{ pet.gender }}</td>
                    <td>{{ pet.age }}</td>
                </tr>
            </ng-template>
        </p-table>

    }
</p-dialog>
